import { useRouter } from 'vue-router';

export default function useOpenHelpDocumentation() {
  const router = useRouter();

  return () => {
    router.push({ name: 'libraryGuidances' });
  };
}
